module.exports = __webpack_public_path__ + "media/images/articles/interview/img02-baaff37de510b5044f795599d38d8e59.png";